export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20soft%20amber%20and%20coral%20tones%2C%20flowing%20ink%20textures%20inspired%20by%20traditional%20Japanese%20art%2C%20subtle%20wave%20patterns%2C%20elegant%20and%20minimal%20design%2C%20warm%20atmospheric%20lighting%2C%20clean%20and%20modern%20aesthetic&width=1800&height=600&seq=jmtt-cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-accent-900/80"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好开启漫画之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200 mb-8 max-w-lg mx-auto">
          加入禁漫天堂，畅享50,000+正版漫画，与1,200万漫画迷一起探索精彩世界
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="bg-background-50 text-primary-700 px-8 py-3.5 rounded-full text-base font-semibold whitespace-nowrap hover:bg-background-100 transition-all duration-200 transform hover:scale-105"
          >
            立即访问官方入口
          </a>
          <a
            href="#"
            className="border-2 border-background-50/70 text-background-50 px-8 py-3.5 rounded-full text-base font-medium whitespace-nowrap hover:bg-background-50/15 transition-all duration-200"
          >
            注册会员
          </a>
        </div>
      </div>
    </section>
  );
}